export default "__VITE_ASSET__f2c10cae__"